<div class="header-main-nav">
  <div class="main-nav-shell">
    <nav class="navbar navbar-expand-sm navbar-light">
      <div class="navbar-grid">
        <!-- Left Side: Logo and Menu -->
        <div class="left-side">
          <div class="navbar-brand" [routerLink]='["/"]'>
            <div class="logo">
              <img src="images/BDO.svg" alt="BDO" />
            </div>
            <div class="app-name">
              <b><span>{{appTitle}}</span></b>
            </div>
          </div>

          @if (isActive) {
            <ul class="navbar-nav main-menu">
              @for (route of routes; track route) {
                <li class="nav-item" [class.active]="isSelfOrParentRoute(route)">
                  <a class="nav-link" [routerLink]="route.path">
                    {{route.data.name}}
                  </a>
                </li>
              }
            </ul>
          }
        </div>

        <!-- Right Side: User Links -->
        <div class="right-side">
          <div class="help">
            <a class="fa fa-2x fa-fw fa-question user-guide" data-toggle="tooltip" data-placement="bottom" title="Link Me to a User Guide" target="_blank" href=""></a>
          </div>

          @if (showMenu) {
            <div class="user-menu" ngbDropdown placement="bottom-right">
              <button type="button" class="user-toggle" id="userMenu" ngbDropdownToggle
                      [ngbTooltip]="getUserTooltip(name | async)" placement="bottom" container="body">
                <i class="fa fa-user-circle fa-lg"></i>
              </button>
              <div ngbDropdownMenu aria-labelledby="userMenu">
                <button type="button" ngbDropdownItem id="logout" (click)="signOut()">Logout</button>
              </div>
            </div>
          }
        </div>
      </div>
    </nav>
  </div>
</div>
